import React from "react";
import { useTypewriter, Cursor } from "react-simple-typewriter";
import { BsCloudLightningFill, BsFacebook } from "react-icons/bs";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import { AiFillTwitterCircle } from "react-icons/ai";
// import { SiYoutubemusic } from "react-icons/si";
import { FiInstagram, FiMail, FiSend } from "react-icons/fi";
import CV from "../../assets/KALYAN_GOTTIMUKKALA_RESUME.pdf";
import { bannerImg } from "../../assets/index";

const Left = () => {
  const [text] = useTypewriter({
    words: ["Web Developer", "Full Stack Developer", "Software QA Analyst"],
    loop: true,
    typeSpeed: 30,
    deleteSpeed: 20,
    delaySpeed: 2000,
  });
  return (
    <div className="w-full lgl:w-5/12 h-full bg-bodyColor rounded-2xl shadow-testShwdow z-10">
      <div className="w-full h-3/5">
        <img
          className="w-full h-full object-cover rounded-2xl"
          src={bannerImg}
          loading="priority"
          alt="bannerImage"
        />
      </div>
      <div className="w-full h-2/5 flex flex-col justify-between border-t-0 rounded-bl-xl rounded-br-xl">
        <div className="flex flex-col items-center gap-2 py-10">
          <h1 className="text-textColor text-4xl font-semibold">Kalyan G</h1>
          <p className="text-base text-designColor tracking-wide">
            {text}
            <Cursor cursorBlinking="false" cursorStyle="|" />
          </p>
          <div className="flex justify-center gap-2 mt-2">
            <span className="hover:text-designColor duration-300 cursor-pointer text-xl">
              <a
                className=""
                href="https://github.com/GottimukkalaKalyan"
                target="_blank"
                rel="noreferrer"
              >
                <FaGithub />
              </a>
            </span>
            <span className="hover:text-designColor duration-300 cursor-pointer text-xl">
              <a
                className=""
                href="https://www.linkedin.com/in/kalyan-gottimukkala/"
                target="_blank"
                rel="noreferrer"
              >
                <FaLinkedin />
              </a>
            </span>
            {/* <span className="hover:text-designColor duration-300 cursor-pointer text-xl">
              <SiYoutubemusic />  
            </span> */}
            <span className="hover:text-designColor duration-300 cursor-pointer text-xl">
              <a
                className=""
                href="https://www.facebook.com/kalyan.gottimukkala.3"
                target="_blank"
                rel="noreferrer"
              >
                <BsFacebook />
              </a>
            </span>
            <span className="hover:text-designColor duration-300 cursor-pointer text-xl">
              <a
                className=""
                href="https://www.instagram.com/kalyan_gottimukkala/"
                target="_blank"
                rel="noreferrer"
              >
                <FiInstagram />
              </a>
            </span>
            <span className="hover:text-designColor duration-300 cursor-pointer text-xl">
              <a
                className=""
                href="https://x.com/Kalyanchakri143?t=juOOVActv2-ZeKHTpODfvg&s=09"
                target="_blank"
                rel="noreferrer"
              >
                <AiFillTwitterCircle />
              </a>
            </span>
            <span className="hover:text-designColor duration-300 cursor-pointer text-xl">
              <a
                className=""
                href="mailto: kalyanchakri1438@gmail.com"
                target="_blank"
                rel="noreferrer"
              >
                <FiMail />
              </a>
            </span>
          </div>
        </div>
        <div className="flex h-14">
          <a
            href={CV}
            target="_blank"
            className="w-1/2 border-t-[1px] borderRight border-t-zinc-800 text-sm tracking-wide uppercase  gap-2 hover:text-designColor duration-300"
            rel="noreferrer"
          >
            <button className="w-full h-full flex justify-center items-center gap-2">
              Download CV <BsCloudLightningFill />
            </button>
          </a>
          <a
            href="mailto: kalyanchakri1438@gmail.com"
            target="_blank"
            className="w-1/2 border-t-[1px] borderRight border-t-zinc-800 text-sm tracking-wide uppercase  gap-2 hover:text-designColor duration-300"
            rel="noreferrer"
          >
            <button className="w-full h-full flex justify-center items-center gap-2">
              Contact me <FiSend />
            </button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Left;
